import { css, styled } from 'styled-components';

import { quillWrapperCssLoadingClass } from 'components/QuillWrapper/quillWrapperConstants';
import { quillWrapperStyles } from 'components/QuillWrapper/quillWrapperStyles';
import { colors, transition } from 'theme/theme';

export const baseRteIntroHeightVar = '--base-rte-intro-height';
export const baseRteOutroHeightVar = '--base-rte-outro-height';
export const baseRteQuillFullscreenHeightVar = '--quill-fullscreen-height';
export const baseRteQuillEditorMinHeightVar = '--quill-editor-min-height';
export const baseRteQuillEditorMaxHeightVar = '--quill-editor-max-height';

export const BaseRteHolder = styled.div<{
  $isFullscreen: boolean;
}>`
  position: relative;
  transition: ${transition};

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      display: grid;
      place-content: stretch;
      width: 100%;
      min-height: 0;
    `}
`;

export const BaseRteQuillHolder = styled.div<{
  $isFullscreen: boolean;
  $hasError: boolean;
}>`
  position: relative;

  &:has(.${quillWrapperCssLoadingClass}) {
    height: calc(var(${baseRteQuillEditorMinHeightVar}) + 12px);
    overflow: hidden;
    filter: blur(10px);
  }

  /* Increase specificity */
  .quill.quill.quill {
    ${quillWrapperStyles};

    .ql-editor {
      min-height: var(${baseRteQuillEditorMinHeightVar});
      max-height: var(${baseRteQuillEditorMaxHeightVar}, 50dvh);

      p {
        margin: 8px 0;
      }
    }

    .ql-container {
      padding-top: calc(10px + var(${baseRteIntroHeightVar}, 0));
      padding-bottom: var(${baseRteOutroHeightVar});

      ${({ $hasError }) =>
        $hasError
          ? css`
              /* We need to apply both outline and border to match the appearance
               * of other input fields in error state. Alternatively, we can use
               * outline-offset. */
              outline: 1px solid ${colors.alertRed};
              border-color: ${colors.alertRed};
            `
          : null}
    }

    ${({ $isFullscreen }) =>
      $isFullscreen &&
      css`
        display: grid;
        grid-template-rows: auto 1fr;
        height: var(${baseRteQuillFullscreenHeightVar});
      `}
  }

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

export const BaseRteWarningHolder = styled.div`
  position: absolute;
  width: 400px;
  max-width: 100%;
  bottom: 0;
  left: 50%;
  font-size: 14px;
  padding: 16px;
  color: ${colors.lightContentGrey};
  border-radius: 4px;
  transform: translateX(-50%) translateY(50%);
  filter: drop-shadow(0 2px 7px rgb(0 0 0 / 20%));
  background: ${colors.white};
`;

export const BaseRteDismissWarningButton = styled.button`
  appearance: none;
  display: inline-block;
  color: ${colors.brandBlue};
  margin-left: 6px;
`;
